import { Config } from "./types";

export const defaultConfig: Config = {
  loadOnStart: {
    cart: true,
    checkout: true,
  },
};
